function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0.166,
  y1: 0.13,
  x2: 0.898,
  y2: 0.931,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1bd1f4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1597ff"
})), /*#__PURE__*/React.createElement("filter", {
  id: "b",
  x: 0,
  y: 0,
  width: 89,
  height: 95,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 107"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Subtraction 7",
  d: "M46.968 77H25.159a6.007 6.007 0 01-6-6v-.985a6 6 0 01.724-2.859A35.561 35.561 0 015.525 54.34 35.4 35.4 0 0135.5 0a35.524 35.524 0 0132.71 21.607 35.336 35.336 0 01-2.479 32.325 35.6 35.6 0 01-13.749 12.786 5.978 5.978 0 01.986 3.3V71a6.007 6.007 0 01-6 6zM35.5 4.739a30.868 30.868 0 00-12.229 59.154v6.368a3 3 0 003 3h19.37a3 3 0 003-3v-6.784A30.869 30.869 0 0035.5 4.739z",
  transform: "translate(9 6)",
  fill: "url(#a)"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 25",
  d: "M.819 0H21.6c.819 0 .645.9.645 2v2c0 1.1-2.29 2-3.108 2H2.845C2.026 6 0 5.1 0 4V2C0 .9 0 0 .819 0z",
  transform: "translate(33.882 86)",
  fill: "#56d2f7"
}));

var SvgSimple = function SvgSimple(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-simple",
    viewBox: "0 0 89 95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSimple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/simple.98a54b1b.svg";
export { ForwardRef as ReactComponent };